export const parsePort = (raw: string | undefined): number => {
  if (raw === undefined) return 8080;
  const port = Number(raw);
  if (
    raw.trim() === "" ||
    !Number.isInteger(port) ||
    port < 0 ||
    port > 65535
  ) {
    throw new Error("PORT must be an integer between 0 and 65535");
  }
  return port;
};
